module.exports = __webpack_public_path__ + "static/media/BodyScan25.c12c0ced.mp3";